import { render, staticRenderFns } from "./CasterStatsSummary.vue?vue&type=template&id=aeaa424a"
import script from "./CasterStatsSummary.vue?vue&type=script&lang=js"
export * from "./CasterStatsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports